import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FloatLabel } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { AuthService } from 'src/app/public/services/auth.service';

@Component({
  selector: 'app-forget',
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, MessageModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    InputOtpModule,
    ToastModule
  ],
  templateUrl: './forget.component.html',
  styleUrl: './forget.component.scss',
  providers: [MessageService]
})
export class ForgetComponent {
  submitted = false;
  isLoading: boolean = false;
  buttonTitle = "Submit"
  form: FormGroup = new FormGroup({
    email: new FormControl(''),
  });
  url: any
  linksend = false;
  constructor(private messageService: MessageService, private coreAuth: AuthService, private router: Router, private formBuilder: FormBuilder) {
    this.url = window.location.href.replace("forget-password", "")

  }
  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]]
      }
    );
  }
  get formError(): any {
    return this.form.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;
    this.buttonTitle = "Loading"
    let param = { ...this.form.value, ...{ resetUrl: this.url + "reset-password" } }
    this.coreAuth.forgetPassword(param).subscribe({
      next: (res) => {

        this.buttonTitle = "Resend"
        this.isLoading = false;
        this.linksend = true;

        // this.toast.success(res.message,'Email Sent');
        this.messageService.add({
          severity: 'success', summary: 'Email Sent', detail:
            'Please check your email for reset password link'
        });
      },
      error: (e) => {
        this.buttonTitle = "Resend"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Resend"
        this.isLoading = false;
      }
    })

  }
  login() {
    this.router.navigate(['login']);
  }
}
